'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Badge, Button, Dialog, Loader, Select } from '@/shared/components/ui';
import { feriadosService } from '@/features/feriados/services/feriadosService';
import { ABRANGENCIA_LABEL, type CalendarioResumo, type Feriado } from '@/features/feriados/types/feriadosTypes';
interface CopiarFeriadosDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  salvando: boolean;
  anoDestino: number;
  anosDisponiveis: CalendarioResumo[];
  onCopiar: (anoOrigem: number) => Promise<boolean>;
}
function formatarDataBR(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  if (!ano || !mes || !dia) return iso;
  return `${dia}/${mes}/${ano}`;
}
function ajustarParaAno(data: string, anoDestino: number): string {
  return `${anoDestino}${data.slice(4)}`;
}
export function CopiarFeriadosDialog(t0) {
  const $ = _c(46);
  const {
    open,
    onOpenChange,
    salvando,
    anoDestino,
    anosDisponiveis,
    onCopiar
  } = t0;
  const [anoOrigem, setAnoOrigem] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [previa, setPrevia] = useState(t1);
  const [carregando, setCarregando] = useState(false);
  let t2;
  let t3;
  if ($[1] !== open) {
    t2 = () => {
      if (open) {
        setAnoOrigem("");
        setPrevia([]);
      }
    };
    t3 = [open];
    $[1] = open;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== anoOrigem || $[5] !== open) {
    t4 = () => {
      if (!open || !anoOrigem) {
        setPrevia([]);
        return;
      }
      let ativo = true;
      setCarregando(true);
      feriadosService.obterCalendario(Number(anoOrigem)).then(calendario => {
        if (!ativo) {
          return;
        }
        const copiaveis = (calendario?.feriados ?? []).filter(_temp);
        setPrevia(copiaveis);
      }).finally(() => {
        if (ativo) {
          setCarregando(false);
        }
      });
      return () => {
        ativo = false;
      };
    };
    t5 = [open, anoOrigem];
    $[4] = anoOrigem;
    $[5] = open;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== anoOrigem || $[9] !== onCopiar || $[10] !== onOpenChange) {
    t6 = async () => {
      const ano = Number(anoOrigem);
      if (!Number.isInteger(ano)) {
        return;
      }
      const ok = await onCopiar(ano);
      if (ok) {
        onOpenChange(false);
      }
    };
    $[8] = anoOrigem;
    $[9] = onCopiar;
    $[10] = onOpenChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleCopiar = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-heading-3 font-heading-3 text-default-font">Copiar feriados de outro ano</span>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== anoDestino) {
    t8 = <div className="flex flex-col">{t7}<span className="text-caption font-caption text-subtext-color">Copia os feriados estaduais/municipais, ajustando as datas para {anoDestino}. Os que já existem são ignorados.</span></div>;
    $[13] = anoDestino;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== anoOrigem || $[16] !== anosDisponiveis) {
    t9 = anosDisponiveis.length === 0 ? <span className="text-body font-body text-subtext-color">Não há outros anos com calendário para copiar.</span> : <Select label="Ano de origem" value={anoOrigem || undefined} onValueChange={setAnoOrigem} placeholder="Selecione o ano">{anosDisponiveis.map(_temp2)}</Select>;
    $[15] = anoOrigem;
    $[16] = anosDisponiveis;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== anoDestino || $[19] !== anoOrigem || $[20] !== carregando || $[21] !== previa) {
    t10 = anoOrigem ? <div className="flex flex-col gap-2"><span className="text-caption-bold font-caption-bold text-default-font">{carregando ? "Carregando\u2026" : `${previa.length} feriado${previa.length === 1 ? "" : "s"} estadual/municipal será${previa.length === 1 ? "" : "\xE3o"} copiado${previa.length === 1 ? "" : "s"}`}</span>{carregando ? <div className="flex h-20 items-center justify-center"><Loader /></div> : previa.length === 0 ? <span className="text-caption font-caption text-subtext-color">O ano de origem não tem feriados estaduais ou municipais.</span> : <div className="flex max-h-64 flex-col gap-1 overflow-y-auto">{previa.map(feriado_0 => <div key={feriado_0.id} className="flex items-center justify-between gap-2 rounded-md px-2 py-1.5 odd:bg-neutral-50"><div className="flex min-w-0 items-center gap-2"><span className="text-caption font-caption text-default-font tabular-nums">{formatarDataBR(ajustarParaAno(feriado_0.data, anoDestino))}</span><span className="text-caption font-caption text-default-font truncate">{feriado_0.nome}</span></div><Badge variant="neutral">{ABRANGENCIA_LABEL[feriado_0.abrangencia]}</Badge></div>)}</div>}</div> : null;
    $[18] = anoDestino;
    $[19] = anoOrigem;
    $[20] = carregando;
    $[21] = previa;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onOpenChange) {
    t11 = () => onOpenChange(false);
    $[23] = onOpenChange;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== salvando || $[26] !== t11) {
    t12 = <Button variant="neutral-secondary" onClick={t11} disabled={salvando}>Cancelar</Button>;
    $[25] = salvando;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = salvando || !anoOrigem || previa.length === 0;
  let t14;
  if ($[28] !== handleCopiar) {
    t14 = () => void handleCopiar();
    $[28] = handleCopiar;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== salvando || $[31] !== t13 || $[32] !== t14) {
    t15 = <Button variant="brand-primary" loading={salvando} disabled={t13} onClick={t14}>Copiar</Button>;
    $[30] = salvando;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t15) {
    t16 = <div className="flex justify-end gap-2">{t12}{t15}</div>;
    $[34] = t12;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t10 || $[38] !== t16 || $[39] !== t8 || $[40] !== t9) {
    t17 = <Dialog.Content className="w-[460px] max-w-[95vw]"><div className="flex w-full flex-col gap-4 p-6">{t8}{t9}{t10}{t16}</div></Dialog.Content>;
    $[37] = t10;
    $[38] = t16;
    $[39] = t8;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== onOpenChange || $[43] !== open || $[44] !== t17) {
    t18 = <Dialog open={open} onOpenChange={onOpenChange}>{t17}</Dialog>;
    $[42] = onOpenChange;
    $[43] = open;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  return t18;
}
function _temp2(calendario_0) {
  return <Select.Item key={calendario_0.ano} value={String(calendario_0.ano)}>{String(calendario_0.ano)}</Select.Item>;
}
function _temp(feriado) {
  return feriado.abrangencia === "ESTADUAL" || feriado.abrangencia === "MUNICIPAL";
}